// App-side endpoint map for the Safety API only. Transport (axios, interceptors,
// idempotency, error shaping) lives in @my/platform/http. Directory endpoints
// live in @my/directory-api — import hooks from there, not from here. As Safety
// grows, prefer the typed client + hooks in @my/safety-api over hand-rolling
// endpoints here; this file mirrors the Depot app's `api/agent.ts` and exists
// mainly for the Diagnostics smoke-test.
import { request, type ApiInfo } from '@my/platform/http';

/** Endpoints scoped to the Safety API (`/safety/api/v1/*`). */
export const Safety = {
  getApiInfo: () => request.get<ApiInfo>('/safety/api/v1/info/api-info'),
};

export const agent = { Safety };
export type { ApiInfo };
